"use strict";

exports.__esModule = true;
exports.default = void 0;
var _isDOMElement = _interopRequireDefault(require("./isDOMElement.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Find one or more DOM elements.
 */
function findAllDOMElements(element) {
  if (typeof element === 'string') {
    var elements = document.querySelectorAll(element);
    return elements.length === 0 ? null : Array.from(elements);
  }
  if (_typeof(element) === 'object' && (0, _isDOMElement.default)(element)) {
    return [element];
  }
  return null;
}
var _default = exports.default = findAllDOMElements;